import { useContext } from 'react';
import { IValidator, ValidatorContext } from '@validation/validator';
export const useValidator = (): IValidator => {
  return useContext(ValidatorContext);
};